<ng-template #content>
  <ion-icon
    *ngIf="iconMatch.indexOf('icon-') < 0; else iconImage"
    [name]="iconMatch"
    slot="start"
    color="dark"
  ></ion-icon>
  <ng-template #iconImage>
    <ion-icon
      [src]="'assets/' + iconMatch"
      slot="start"
      color="dark"
    ></ion-icon>
  </ng-template>
</ng-template>
